"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class AddToCartCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackAddToCartEvent(this.input);
    }
}
exports.AddToCartCommand = AddToCartCommand;
